// src/services/CategoryService.ts
import { api } from '../utils/api'
import type { Category } from '../types/@types/category'

interface CategoryApi {
  id: string
  name: string
  icon: string
  createdAt?: string
}

function mapCategory(category: CategoryApi): Category {
  const { id, ...rest } = category
  return { id: id, ...rest }
}

export async function getCategories(): Promise<Category[]> {
  const { data } = await api.get<CategoryApi[]>('/categories')
  return data.map(mapCategory)
}

export async function createCategory(category: Omit<Category, 'id'>): Promise<Category> {
  const { data } = await api.post<CategoryApi>('/categories', category)
  return mapCategory(data)
}

export async function updateCategory(id: string, category: Omit<Category, 'id'>): Promise<Category> {
  const { data } = await api.put<CategoryApi>(`/categories/${id}`, category)
  return mapCategory(data)
}

export async function deleteCategory(id: string): Promise<string> {
  const { data } = await api.delete<{ message: string }>(`/categories/${id}`)
  return data.message
}
